import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// 导入 i18n 配置（必须在 App 渲染之前）
import './i18n'
// 导入 vConsole 调试工具
import { initVConsole } from './utils/vconsole'
// 导入主题工具（在渲染前初始化深浅色主题，避免首屏闪烁）
import { resolveTheme, applyTheme } from './utils/theme'

// 控制台输出当前环境信息
console.log('环境名称:', import.meta.env.VITE_ENV_NAME || 'development');
console.log('服务地址:', import.meta.env.VITE_API_BASE_URL);
console.log('主题模式:', import.meta.env.VITE_THEME_MODE || 'auto');

// 初始化 vConsole
initVConsole();

// 初始化主题：解析环境变量 / App 桥接 getThemeMode()，设置 html[data-theme]
resolveTheme()
  .then((theme) => applyTheme(theme))
  .catch((e) => {
    // 主题解析失败时默认深色，不阻塞页面渲染
    console.error('[Theme] 主题初始化失败，默认深色:', e);
    applyTheme('dark');
  });

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
